import { createSelector } from '@ngrx/store';
import { CoreState, getCoreState } from '../../../store/reducers';
import { CurrencyState } from '../reducers/currency.reducer';

const getCurrencyState = createSelector(
  getCoreState,
  (state: CoreState) => state.currency,
);

const getSelected = (state: CurrencyState) => state.selected;

export const getCurrencySelected = createSelector(
  getCurrencyState,
  getSelected,
);
